export const BEGINNER_CONTENT_BY_COURSE = {
  cyn_basics: {
    title: 'Foundations of Filmmaking',
    overview:
      'The Foundations of Filmmaking is a foundational course designed for aspiring filmmakers who want to understand how cinema works before choosing a specialization. The course introduces students to the language of film, storytelling, direction, cinematography, editing, sound, production design, and the overall filmmaking workflow from pre-production to distribution.\n\nThrough practical examples, film analysis, assignments, and industry-oriented learning, students will gain clarity about different departments in filmmaking, understand industry hierarchy and job roles, and discover where their interests and strengths lie within the world of cinema.',
    whatYouLearn: [
      'Understand the fundamentals of film language and cinematic storytelling',
      'Learn how films are developed from script to screen',
      'Explore the responsibilities of different filmmaking departments',
      'Analyze scenes, films, and visual storytelling techniques',
      'Understand pre-production, production, and post-production workflows',
      'Learn the basics of screenwriting, direction, cinematography, editing, and sound',
      'Gain awareness of industry hierarchy, on-set roles, and career pathways in cinema',
    ],
    skills: [
      'Film Analysis',
      'Cinematic Thinking',
      'Film Workflow Understanding',
      'Creative Collaboration',
      'Film Language & Grammar',
    ],
  },
  cyn_direction: {
    title: 'Foundations of Direction',
    overview:
      'The Foundations of Direction course introduces students to the creative and practical responsibilities of a film director. From understanding storytelling and visual language to working with actors and planning scenes, this course helps students think like directors and understand how cinematic vision is translated onto screen.',
    whatYouLearn: [
      'Understand the role and responsibilities of a film director',
      'Learn the fundamentals of cinematic storytelling and film language',
      'Understand narrative, story structure, character arcs, conflict, and scene design',
      'Learn visual storytelling through framing, shot selection, and composition',
      'Learn shot division, shot listing, and storyboarding basics',
      'Understand continuity and scene coverage during shoots',
      'Learn how directors work with actors, emotions, and rehearsals',
      'Understand communication and collaboration on a film set',
      'Learn how editing influences storytelling and rhythm in films',
      'Shoot and direct scenes through practical assignments and exercises',
    ],
    skills: [
      'Directorial Thinking',
      'Scene Visualization',
      'Shot Planning',
      'Storyboarding Basics',
      'Actor Direction',
      'Visual Communication',
      'Blocking & Rehearsal Techniques',
      'Cinematic Composition',
      'On-Set Collaboration',
      'Narrative Understanding',
      'Basic Production Management',
    ],
  },
  cyn_editing: {
    title: 'Foundations of Editing',
    overview:
      'The Foundations of Editing course introduces students to the art and psychology of film editing through both creative storytelling and technical workflow. The course explores how editing shapes emotion, rhythm, pacing, and audience perception while helping students understand the foundations of cinematic continuity and visual narrative construction.\n\nStudents will learn editing practically through dialogue sequence editing, pacing exercises, sound integration, and scene construction while also understanding common beginner mistakes, editing psychology, and professional post-production workflows used in the film industry.',
    whatYouLearn: [
      'Understand the role of an editor in cinematic storytelling',
      'Learn the history and evolution of film editing',
      'Understand editing software interface and editing workflow',
      'Learn continuity editing, match cuts, and the 180-degree rule',
      'Understand pacing, rhythm, and the psychology of cuts',
      'Edit dialogue scenes and understand conversational rhythm',
      'Learn different transition styles',
      'Understand cutting techniques and narrative structure',
      'Learn color correction, basic grading, and export workflow',
      'Learn portfolio-building and professional editing workflow fundamentals',
    ],
    skills: [
      'Narrative Editing',
      'Continuity Editing',
      'Dialogue Scene Editing',
      'Rhythm & Pacing',
      'Visual Storytelling Through Cuts',
      'Editing Psychology',
      'Sound Synchronization',
      'Timeline Management',
      'Film Grammar & Continuity',
      'Professional Editing Workflow',
      'Post-Production Fundamentals',
    ],
  },
  cyn_screenwriting: {
    title: 'Foundations of Screenwriting',
    overview:
      'The Foundations of Screenwriting is a foundational course designed for aspiring writers who want to understand how stories are built for the screen. The course introduces students to the craft of screenplay writing- story structure, character development, dialogue, scene construction, industry-standard formatting, and the process of shaping an idea into a script ready for production.',
    whatYouLearn: [
      'Understand the fundamentals of story structure and screenplay format',
      'Learn how to develop compelling characters and character arcs',
      'Explore the building blocks of scene construction and dialogue',
      'Analyze scripts and films to understand how story choices translate to the screen',
      'Understand the process from logline to treatment to first draft',
      'Learn industry-standard screenplay formatting and terminology',
      'Gain awareness of the writer\'s role within the filmmaking process and career pathways for screenwriters'
    ],
    skills: [
      'SCRIPT ANALYSIS',
      'STORY STRUCTURE',
      'CHARACTER DEVELOPMENT',
      'DIALOGUE WRITING',
      'SCREENPLAY WRITING',
      'SCREENPLAY FORMATTING',
    ],
  },
};
